package com.arena_web.ui.components.forms

import androidx.compose.runtime.Composable
import com.arena_web.ui.theme.AppColors
import com.arena_web.ui.theme.LocalSportColors
import com.arena_web.ui.theme.toRgbString
import com.arena_web.ui.utils.Constants
import com.arena_web.ui.utils.s
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.css.*

@Composable
fun Toggle(
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier
) {
    val sportColors = LocalSportColors.current
    // Track: 51x31, pill shape
    Box(
        modifier = modifier
            .styleModifier {
                property("width", s(51))
                property("height", s(31))
                property("min-width", s(51))
                property("border-radius", s(16))
                property("position", "relative")
                property("cursor", "pointer")
                property("transition", "background-color ${Constants.ANIMATION_NORMAL}ms ease")
                property("box-sizing", "border-box")
                if (checked) {
                    property("background", sportColors.primary.toRgbString())
                } else {
                    property("background", "rgba(120, 120, 128, 0.32)")
                }
            }
            .onClick { onCheckedChange(!checked) },
        contentAlignment = Alignment.CenterStart
    ) {
        // Knob: 27x27, white circle with shadow
        Box(
            modifier = Modifier
                .styleModifier {
                    property("width", s(27))
                    property("height", s(27))
                    property("border-radius", "50%")
                    property("background", "linear-gradient(180deg, #F0F0F0 0%, #FFFFFF 100%)")
                    property("box-shadow", "0 3px 8px rgba(0, 0, 0, 0.15), 0 1px 1px rgba(0, 0, 0, 0.06)")
                    property("position", "absolute")
                    property("top", s(2))
                    if (checked) {
                        property("left", s(22))
                    } else {
                        property("left", s(2))
                    }
                    property("transition", "left ${Constants.ANIMATION_NORMAL}ms ease")
                }
        )
    }
}
